import { createStore } from 'vuex'
import axios from 'axios';

export default createStore({
	state: {
		name: "Mark",
		quote: "",
		quotes: [],
		backendurl: "http://localhost:3000/",
		so_number: "",
		soDetail: "",
		saleDocType: "1111",
		saleOrganize: "2222",
		type: "",
		search_text: "",
		notify: "",
		FirstItem: "",
		customerId: "",
		raw_SO: "",
	},
	mutations: {
		getDataNotify(state) {
			axios.get(process.env.VUE_APP_API_URL_BACKEND + 'notify')
				.then(res => {
					const date = new Date();
					const start = new Date(res.data.dateStart);
					const end = new Date(res.data.dateEnd);
					if (date > start && date < end) {
						state.notify = res.data.text;
					}
				})
				.catch(err => {
					console.error(err);
				})
		},
		getAllTask(state) {
			fetch(this.state.backendurl + "tasks")
				.then(res => res.json())
				.then(data => {
					state.quotes = data;
				})
		},
		async getSONumberDetail(state) {
			await fetch(this.state.backendurl + "data/" + state.so_number)
				.then(res => res.json())
				.then(data => {
					state.soDetail = data;
					return data
				})
		},
		async getSONumberDetail_post(state) {
			await axios.post(this.state.backendurl + "data", {
				soNumber: state.so_number,
				saleDocType: state.saleDocType,
				saleOrganize: state.saleOrganize,
				type: state.type,
			})
				.then(res => {
					// res.json()
					state.soDetail = res.data;
					return res
				})
				.catch(err => {
					console.error(err);
				})
		}

	},
	getters: {
		getSpecificTask: state => id => {
			return state.quotes.filter(q => q._id == id)[0];
		},
	}

})
